export enum InvoiceType {
  PLATFORM_FEE = "PLATFORM_FEE",
  FLOAT = "FLOAT",
}
